<template>
  <div>
    <!-- Widget flotante de llamar fichas -->
    <LlamarFichas v-if="globalStore.user.id" :user-id="globalStore.user.id" />
  <v-card outlined :loading="loading">
    <v-tabs fixed-tabs v-model="tab">
      <v-tab>Arqueo ({{ fecha | localDate }})</v-tab>
      <v-tab>Consumo de agua</v-tab>
      <v-tab>Otros ingresos</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-col
            cols="12"
            sm="6"
            offset-sm="3"
            class="mt-0"
        >
          <v-subheader class="font-weight-bold" >
<!--            RESUMEN DIARIO-->
<!--            ({{ fecha | localDate }}) -->
            <v-text-field v-model="fecha" type="date" label="RESUMEN DIARIO" placeholder="Placeholder" outlined dense hide-details></v-text-field>
            <v-spacer/>
            <v-btn outlined icon @click="getResumen(fecha)" title="Actualizar resumen" small>
              <v-icon>mdi-check-circle-outline</v-icon>
            </v-btn>
          </v-subheader>
          <v-divider/>
          <v-list class="pa-0" dense>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Consumo de agua</v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                {{ resumen.totalConsumoAgua | round}} Bs.
              </v-list-item-icon>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Otros ingresos</v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                {{ resumen.totalOtroIngreso | round }} Bs.
              </v-list-item-icon>
            </v-list-item>
            <v-divider/>
            <v-list-item class="font-weight-bold">
              <v-list-item-content>
                <v-list-item-title>Total</v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                {{ total | round }} Bs.
              </v-list-item-icon>
            </v-list-item>
          </v-list>
          <v-subheader class="font-weight-bold" >
            <div class="text-center full-width" >CHEQUES RECIBIDOS DE CLIENTES</div>
          </v-subheader>
          <v-divider/>
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
              <tr>
                <th>Cheque Nº</th>
                <th>BANCO</th>
                <th>GIRADO POR:</th>
                <th>IMPORTE <br> <span class="font-weight-bold"> {{chequesTotal}} Bs </span></th>
                <th>Opciones</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(r,i) in recaudacionStore.cheques" :key="i">
                <td>{{i+1}}</td>
                <td>{{ r.banco }}</td>
                <td>{{ r.girado }}</td>
                <td class="text-right">{{ r.importe }}</td>
                <td>
                  <v-icon
                      color="grey"
                      @click="eliminarCheque(i)"
                  >
                    mdi-delete-circle-outline
                  </v-icon>
                </td>
              </tr>
              <tr>
                <td></td>
                <td>
                  <v-text-field
                      v-model="recaudacionStore.cheque.banco"
                      outlined
                      dense
                      hide-details
                      placeholder="Banco"
                  />
                </td>
                <td>
                  <v-text-field
                      v-model="recaudacionStore.cheque.girado"
                      outlined
                      dense
                      hide-details
                      placeholder="Girado por"
                  />
                </td>
                <td>
                  <v-text-field
                      class="text-right"
                      v-model="recaudacionStore.cheque.importe"
                      outlined
                      dense
                      type="number"
                      hide-details
                      placeholder="Importe"
                  />
                </td>
                <td>
                  <v-icon
                      color="grey"
                      @click="addCheque()"
                  >
                    mdi-plus-circle-outline
                  </v-icon>
                </td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-subheader class="font-weight-bold" >
            <div class="text-center full-width" >MONTO EN EFECTIVO</div>
          </v-subheader>
          <v-divider/>
          <v-row class="pa-2" align="center" justify="center">
            <v-col cols="4">
              <v-text-field label="Monto en efectivo" outlined dense hide-details v-model="recaudacionStore.dinero" type="number" />
            </v-col>
            <v-col cols="8" class="text-right font-weight-bold">
              {{ dinerototal}}-{{total}} = {{restante(dinerototal,total)}} Bs <v-chip :color="dinerototal<total?'red':'green'" text-color="white" small> {{ dinerototal < total ?'Faltante':dinerototal == total ?'Igual':'Sobrante'}}</v-chip>
            </v-col>
          </v-row>
          <v-list class="mt-0 grey--text" dense>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Cantidad facturas cobradas</v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                {{ resumen.cantidadFacturas | round }}
              </v-list-item-icon>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Cantidad facturas anuladas</v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                {{ resumen.cantidadAnuladas | round }}
              </v-list-item-icon>
            </v-list-item>
          </v-list>

          <v-divider/>

          <p class="text-right mt-5">
            <v-checkbox
              v-model="estoyDeAcuerdo"
              label="He revisado y estoy de acuerdo con la información que se muestra en el arqueo"
            />

            <v-btn color="secundary" outlined @click="imprimirArqueo()" :disabled="!estoyDeAcuerdo">
              <v-icon>mdi-printer</v-icon>
              Imprimir Arqueo
            </v-btn>
          </p>
        </v-col>
      </v-tab-item>

      <v-tab-item>
        <v-col cols="12" md="10" offset-md="1">
          <recaudacion-consumo-agua/>
        </v-col>
      </v-tab-item>

      <v-tab-item>
        <v-col cols="12" md="8" offset-md="2">
        <recaudacion-otro-ingreso/>
        </v-col>
      </v-tab-item>
    </v-tabs-items>

    <div id="printArqueo">
      <head-report :title="'INGRESOS DE CAJA'"/>
      <recaudacion-arqueo />
    </div>

  </v-card>
  </div>
</template>

<script lang="ts">
import {Component, Vue} from "vue-property-decorator";
import {recaudacionStore} from "@/store/recaudacionStore";
import RecaudacionConsumoAgua from "@/views/recaudaciones/RecaudacionConsumoAgua.vue";
import {Alert} from "@/addons/Alert";
import RecaudacionOtroIngreso from "@/views/recaudaciones/RecaudacionOtroIngreso.vue";
import {RecaudacionService} from "@/services/RecaudacionService";
import RecaudacionArqueo from "@/views/recaudaciones/RecaudacionArqueo.vue";
import HeadReport from "@/components/HeadReport.vue";
import {Reporte} from "@/addons/Reporte";
import {globalStore} from "@/store/globalStore";
import { DateTime } from "luxon";
import LlamarFichas from '@/components/LlamarFichas.vue';
@Component({
  name: "RecaudacionIndex",
  components: {HeadReport, RecaudacionArqueo, RecaudacionOtroIngreso, RecaudacionConsumoAgua, LlamarFichas}
})
export default class RecaudacionIndex extends Vue {
  private recaudacionStore = recaudacionStore();
  private globalStore = globalStore();
  private recaudacionService = RecaudacionService.getInstance();
  private tab:any = null;
  private estoyDeAcuerdo = false;
  fecha = DateTime.now().toFormat('yyyy-MM-dd');

  get loading(): boolean {
    return this.recaudacionStore.loading
  }

  get resumen(): any {
    return this.recaudacionStore.resumen;
  }

  get total(){
    const total = parseFloat(this.resumen.arqueoTotal);
    if (isNaN(total)) return 0;
    return Math.round(total * 100) / 100;
  }

  restante( num1: any,num2: any){
    const total = parseFloat(num1) - parseFloat(num2);
    if (isNaN(total)) return 0;
    return Math.round(total * 100) / 100;
  }

  get dinerototal(){
    const total = parseFloat(String(this.recaudacionStore.dinero)) + parseFloat(String(this.chequesTotal));
    if (isNaN(total)){
      return parseFloat(String(this.chequesTotal))
    }
    return Math.round(total * 100) / 100;
  }

  eliminarCheque(index: number) {
    Alert.confirm("¿Está seguro de eliminar el cheque?").then(res => {
      if (res.isConfirmed) {
        this.recaudacionStore.cheques.splice(index, 1);
      }
    })
  }
  addCheque(){
    if (this.recaudacionStore.cheque.banco === '' || this.recaudacionStore.cheque.girado === '' || this.recaudacionStore.cheque.importe === ''){
      Alert.error('Debe completar todos los campos');
      return;
    }
    this.recaudacionStore.cheques.push(this.recaudacionStore.cheque);
    this.recaudacionStore.cheque = {
      banco: '',
      girado: '',
      importe: ''
    }
  }

  mounted(){
    this.getResumen(this.fecha);
  }

  imprimirArqueo() {
    this.getResumen(this.fecha);
    Alert.confirm("Se va ha imprimir el arqueo de la recaudación diaria").then(result => {
      if (result.isConfirmed) {
        this.imprimir();
      }
    })
  }

  imprimir() {
    this.globalStore.fecha = DateTime.now().toFormat('yyyy-MM-dd HH:mm:ss');
    setTimeout(() => {
      const p = new Reporte('printArqueo');
      p.orientacion = 'vertical';
      p.imprimir();
    }, 100);
  }

  getResumen(fecha:any){
    this.recaudacionService.getResumen(fecha);
  }
  get chequesTotal(){
    let t=0;
    this.recaudacionStore.cheques.forEach(c=>{
      t+= parseFloat(c.importe)
    })
    t= Math.round(t * 100) / 100;
    return t
  }
}
</script>

<style scoped>
.full-width {
  width: 100%;
}
</style>
